import { api } from './api';
import { TimelineData } from '../types/timeline.types';

export const timelineService = {
  /**
   * Get SEO maturity timeline for a site
   */
  async getTimeline(siteId: number): Promise<TimelineData> {
    const response = await api.get<TimelineData>(`/earlystage/sites/${siteId}/timeline`);
    return response.data;
  }
};
